import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets, colors }) => ({
    topBar: {
        padding: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: colors.dark.dark4,
    },
    editor: {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1,
    },
    body: {
        ...typographyPresets.bodyPrimary,
        fontSize: '20px',
        flexGrow: '1',
        backgroundColor: colors.black,
        color: colors.white,
        padding: '32px',
    },
}))
